export const CONFIGURATION = {
    simulateProduction: false,
    api_url_production: "https://noiro-api-server-prod.herokuapp.com/api/v1",
    api_url_dev: "http://localhost:5000/api/v1",
}